import { Fragment } from 'react';
import { PageNavbar } from '../account';
import { Container } from '@/components/container';
import { useLayout } from '@/providers';
import { Toolbar, ToolbarHeading, ToolbarPageTitle } from '@/partials/toolbar';
import BookingsListing from './BookingListings';

const BookingManagement = () => {
  const { currentLayout } = useLayout();
  return (
    <Fragment>
      <PageNavbar />
      {currentLayout?.name === 'demo1-layout' && (
        <Container>
          <Toolbar>
            <ToolbarHeading>
              <ToolbarPageTitle text="Booking Management" />
            </ToolbarHeading>
          </Toolbar>
          <div className="mt-6">
            <BookingsListing />
          </div>
        </Container>
      )}
    </Fragment>
  );
};

export { BookingManagement };
